import { render, staticRenderFns } from "./ProductsDialog.vue?vue&type=template&id=25b198f5&scoped=true&"
import script from "./ProductsDialog.vue?vue&type=script&lang=js&"
export * from "./ProductsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b198f5",
  null
  
)

export default component.exports